import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'
import ScrollMenu from 'react-horizontal-scrolling-menu';

// import other components within the same project here
import Config from "../../Config.jsx";

import Localization from "../../Localization.jsx"
import Helper from "../../Helper.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  CardActionArea,
  CardActions,
  Icon,
  IconButton,
  Tooltip,
} from '@material-ui/core';

import { withTheme } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

class StageElementListView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      deleteElementID: "",
    };
    autoBind(this);
  }

  componentDidMount() {
    let divHeight = this.refs.div.getBoundingClientRect().height;
    this.props.parent.setState({
      stageElementListViewHeight: divHeight,
    });
    this.props.parent.state.stageElementListViewHeight = divHeight;
  }

  editElementClicked(index) {
    let element = this.props.parent.state.stageData['playback_list'][index];
    this.props.parent.props.parent.editStageElement(element);
  }

  locateElementPositionClicked(element) {
    let playbackHotspot = Helper.convertXYtoYawPitch(parseFloat(element['pos_x']), parseFloat(element['pos_y']));
    this.props.parent.refs.stageMediaView.refs.stageMediaImage.lookAt(playbackHotspot.pitch, playbackHotspot.yaw);
  }

  updateElementTriggerTimeClicked(elementID) {
    let requestObj = {};
    requestObj['playback_id'] = elementID;
    requestObj['trigger_time'] = this.props.parent.refs.stageMediaView.state.playbackTime;
    this.props.root.refs.API.request("update_playback", requestObj, this.updateElementTriggerTimeOK, this.updateElementTriggerTimeFailed);
  }

  updateElementTriggerTimeOK(res) {
    this.reloadPlayback();
  }

  updateElementTriggerTimeFailed(err) {
    console.log("update element trigger time failed");
  }

  deleteElementClicked(element) {
    let elementID = element['id'];
    this.setState({ deleteElementID: elementID });
    this.state.deleteElementID = elementID;
    let dialogText = {
      title: Localization.strings.DELETE + " " + Config.GET_PLAYBACK_CONFIG(parseInt(element.kind))['name'] + " at " + Helper.fToHHMMSS(element['trigger_time']),
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    };
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteElementConfirmClicked, this.deleteElementCancelClicked);
  }

  deleteElementConfirmClicked() {
    if (this.state.deleteElementID != "") {
      this.props.root.refs.API.request("delete_playback", {playback_id: this.state.deleteElementID}, this.deleteElementOK, this.deleteElementFailed);
    }
  }

  deleteElementCancelClicked() {
    this.setState({ deleteElementID: "" });
    this.state.deleteElementID = "";
  }

  deleteElementOK(res) {
    this.reloadPlayback();
  }

  deleteElementFailed(err) {
    console.log("delete element failed");
  }

  reloadPlayback() {
    this.props.parent.updateStageDetail(this.props.stageData['id']);
  }

  stageHasFile() {
    let result = false;
    let stageData = this.props.parent.state.stageData;
    if (stageData['movie_list'].length > 0) {
      result = true;
    }
    return result;
  }

  render() {
    let playbackList = this.props.parent.state.stageData['playback_list'];
    let is360View = false;
    let stageKind = this.props.parent.state.stageData['kind'];
    if (stageKind == "1") {
      if (this.props.parent.refs.stageMediaView && this.props.parent.refs.stageMediaView.refs.imageHolder) {
        is360View = this.props.parent.refs.stageMediaView.refs.imageHolder.state.is360View;
      }
    }
    let playbackTime = 0;
    if (this.props.parent.refs.stageMediaView) {
      playbackTime = this.props.parent.refs.stageMediaView.state.playbackTime;
    }

    let data = playbackList.map( (row, i) => {
      let icon = Config.GET_PLAYBACK_CONFIG(parseInt(row['kind']))['icon'];
      let hasPosition = Config.GET_PLAYBACK_CONFIG(parseInt(row['kind']))['hasPosition'];
      let triggerTime = parseInt(row['trigger_time']);
      let countdownLimit = parseInt(row['countdown_limit']);
      let elementHighlighted = false;
      if (countdownLimit != 0) {
        elementHighlighted = (playbackTime >= triggerTime && playbackTime <= triggerTime + countdownLimit);
      }
      else {
        elementHighlighted = (playbackTime == triggerTime);
      }
      return (
        <div key={i} style={{padding:'1px 14px 6px 1px', width:'170px'}}>
          <Card>
            <Tooltip title={Localization.strings.EDIT} placement="top">
              <CardActionArea
                onClick={()=>this.editElementClicked(i)}
              >
                <CardHeader
                  style={{backgroundColor:(elementHighlighted? this.props.theme.palette.primary.main : ""), color:(elementHighlighted? 'White' : 'Black')}}
                  avatar={<Icon>{icon}</Icon>}
                  title={Helper.fToHHMMSS(triggerTime)}
                  titleTypographyProps={{color:(elementHighlighted? 'inherit' : 'textPrimary')}}
                />
                <CardContent>
                  {row['content']}
                </CardContent>
              </CardActionArea>
            </Tooltip>
            <CardActions>
              <If condition={hasPosition && stageKind == "1"}>
                <Then>
                  <Tooltip title={Localization.strings.LOCATE_ELEMENT} placement="top">
                    <span>
                      <IconButton disabled={!elementHighlighted || !is360View} onClick={()=>this.locateElementPositionClicked(row)}>
                        <Icon>my_location</Icon>
                      </IconButton>
                    </span>
                  </Tooltip>
                </Then>
              </If>
              <Tooltip title={Localization.strings.UPDATE_TIME} placement="top">
                <IconButton onClick={()=>this.updateElementTriggerTimeClicked(row['id'])}>
                  <Icon>timer</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title={Localization.strings.DELETE} placement="top">
                <IconButton onClick={()=>this.deleteElementClicked(row)}>
                  <Icon>delete</Icon>
                </IconButton>
              </Tooltip>
            </CardActions>
          </Card>
        </div>
      );
    })

    if (playbackList.length == 0) {
      let list = [null];
      data = list.map(row => {
        return (
          <div style={{padding:'1px 14px 6px 1px', width:'170px'}}>
            <Card>
              <CardActionArea
                disabled={!this.stageHasFile()}
                onClick={this.props.parent.props.parent.addStageElement}
              >
                <CardHeader
                  style={{color:(this.stageHasFile()? 'Black' : grey[400])}}
                  avatar={<Icon>add</Icon>}
                  title={Localization.strings.ADD}
                  titleTypographyProps={{color:(this.stageHasFile()? 'textPrimary' : 'inherit')}}
                />
                <CardContent
                  style={{color:(this.stageHasFile()? 'Black' : grey[400])}}
                >
                  {Localization.strings.NEW_STAGE_ELEMENT}
                </CardContent>
                <CardActions>
                  <IconButton>
                    <Icon></Icon>
                  </IconButton>
                </CardActions>
              </CardActionArea>
            </Card>
          </div>
        );
      })
    }

    return (
      <div ref="div">
        <ScrollMenu
          ref="scrollMenu"
          data={data}
          arrowLeft={<IconButton><Icon>keyboard_arrow_left</Icon></IconButton>}
          arrowRight={<IconButton><Icon>keyboard_arrow_right</Icon></IconButton>}
          hideArrows={true}
          hideSingleArrow={true}
          alignCenter={false}
        />
      </div>
    )
  }
}

export default withTheme(StageElementListView);
